import { Message } from 'view-design'

function GetLableByValue(value, arr) {
    let str = "";
    for (let el of arr) {
        if (el.value === value) {
            str = el.label;
            break;
        } else if (el.children && el.children.length) {
            str = GetLableByValue(value, el.children);
            if (str) {
                break;
            }
        }
    }
    return str;
}
function toFixed(num, d) {
    num *= Math.pow(10, d);
    num = Math.round(num);
    return num / (Math.pow(10, d));
}
function UseMap(callback) {
    // let script = document.getElementById('bddtscript');
    let script = window.BMap;
    if (!script) {
        script = document.createElement("script");
        //   script.src = `//api.map.baidu.com/api?v=3.0&ak=76bf80490799c76e393b84cb8da4c856&callback=initialize`;
        script.src = `//api.map.baidu.com/api?type=webgl&v=1.0&ak=76bf80490799c76e393b84cb8da4c856&callback=initialize`;
        document.body.appendChild(script);
        window.initialize = function () {
            // let uiscript = document.getElementById('bddtscript-ui');
            callback();
        };
    } else {
        callback();
    }
}

function setTitle(title) {
    // alert('nav title set'+title);
    document.title = title;
}

function FormatDate(t, reg) {
    if (t) {
        return (new Date(String(t).replace('T', ' ').replace(/\-/g, '/'))).Format(reg);
    }
    return t;
}

function msToDate(msec) {
    let datetime = new Date(msec);
    let year = datetime.getFullYear();
    let month = datetime.getMonth();
    let date = datetime.getDate();
    let hour = datetime.getHours();
    let minute = datetime.getMinutes();
    let second = datetime.getSeconds();

    let result1 = year +
        '-' +
        ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) +
        '-' +
        ((date + 1) < 10 ? '0' + date : date) +
        ' ' +
        ((hour + 1) < 10 ? '0' + hour : hour) +
        ':' +
        ((minute + 1) < 10 ? '0' + minute : minute) +
        ':' +
        ((second + 1) < 10 ? '0' + second : second);

    let result2 = year +
        '-' +
        ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) +
        '-' +
        ((date + 1) < 10 ? '0' + date : date);

    let result = {
        hasTime: result1, //--->2017-10-23 17:20:13
        withoutTime: result2 //--->2017-10-23
    };

    return result;
}

function skipCount(MaxResultCount, PageIndex) {
    return PageIndex * MaxResultCount - MaxResultCount
}

// async await异常捕获(如接口404 500 跨域等)
function awaitWrap(promise) {
    return promise.then(res => [null, res]).catch(err => [err, null])
}

let messageInstance = null;
const ResetMessage = (options) => {
    if (!messageInstance) {
        Message[options.type](options);
    }
    messageInstance = true;
    setTimeout(() => {
        messageInstance = null;
    }, 3000);
};
['error', 'success', 'info', 'warning'].forEach((type) => {
    ResetMessage[type] = (options) => {
        if (typeof options === 'string') {
            options = {
                content: options
            };
        }
        options.type = type;
        return ResetMessage(options);
    };
});

function setMax(val) {
    return Number(val) > 100 ? 100 : Number(val)
}

function formatDateToX(val) {
    if (!val) {
        return ""
    }
    let value = null;
    if (typeof val != "string") {
        value = String(val)
    }
    value = val.replace(/-/g, "/");
    return value;
}
function back() {
    window.history.go(-1);
}
function classType(item) {
    if (!item) return "";
    if (
        new Date(formatDateToX(item.startTime)).getTime() >
        new Date().getTime()
    ) {
        return 4;
    }

    if (item.isOut) {
        if (item.learnTimesCelaId) {
            return 3;
        }
        if (
            new Date(formatDateToX(item.endTime)).getTime() >
            new Date().getTime()
        ) {
            return 2;
        } else {
            return 1;
        }
    }

    if (item.classType == 1) {
        if ((item.autoClassRequiredTimes / 3600) >= item.classTimes
            && (item.autoClassElectiveTimes / 3600) >= item.classElectiveTimes) {
            return 3;
        }

    } else {
        if (item.curTimes >= item.classTimes * 3600) {
            return 3;
        }
    }



    if (
        new Date(formatDateToX(item.endTime)).getTime() >
        new Date().getTime()
    ) {
        return 2;
    } else {
        return 1;
    }
}
function getClassBtn(type, item) {

    if (type == 'end') {
        if (item.classType == 1) {
            return (item.autoClassRequiredTimes / 3600) >= item.classTimes
                && (item.autoClassElectiveTimes / 3600) >= item.classElectiveTimes
        }
        return (!item.isOut && classType(item) == 3) ||
            (item.isOut && item.learnTimesCelaId)
    }
    if (type == 'study') {
        if (item.classType == 1) {
            return classType(item) == 2 &&
                ((item.autoClassRequiredTimes / 3600) < item.classTimes
                    || (item.autoClassElectiveTimes / 3600) < item.classElectiveTimes)
        }
        return (!item.isOut && classType(item) == 2) ||
            (item.isOut && !item.learnTimesCelaId && classType(item) == 2)
    }

}

function getClassState(item) {
    let typeObj = {
        1: "已结束",
        2: "进行中",
        3: "已结业",
        4: "未开始",
    }
    return typeObj[classType(item)]
}

// 班级是否已结束（classType 为 1 表示已结束，学习课程将不会计算学时）
function isClassEnded(item) {
    return classType(item) == 1
}
function getDefaultCover() {
    let defaultCover = ['scgbwlxy-y.png', 'scgbwlxy-r.png']
    return 'https://uploadcdn.scgb.gov.cn/filedownload/static/' + defaultCover[Math.floor(Math.random() * defaultCover.length)]
}



export { getDefaultCover, ResetMessage, back, getClassBtn, getClassState, isClassEnded, formatDateToX, setMax, GetLableByValue, setTitle, UseMap, FormatDate, msToDate, toFixed, skipCount, awaitWrap };